import { call, put } from "redux-saga/effects";

import {
  fetchDcStoreData,
  fetchDcStoreDataSuccess,
  fetchStoreOrderData,
  fetchStoreOrderDataSuccess,
  fetchBuyerCommentsData,
  fetchBuyerCommentsDataSuccess,
  fetchDcStoreDataError,
  fetchStoreOrderDataError,
  fetchBuyerCommentsDataError,
  fetchDcStoreTotal,
  fetchDcStoreTotalSuccess,
  fetchDcStoreTotalError,
  fetchStoreOrderTotal,
  fetchStoreOrderTotalSuccess,
  fetchStoreOrderTotalError,
} from "../modules/orderHistory";
import {
  getDCOrderHistoryData,
  getStoreOrderHistoryData,
  getBuyerCommentsData,
  getDCOrderHistoryTotal,
  getStoreOrderHistoryTotal,
} from "../end-points/orderHistory";
import { transformFilterOptions } from "../../utils/formatFilterOptions";
import { ISuccessResponse } from "../../types/response.types";
import { IBuyerComments, IDCStore, IStoreOrder } from "../../types/order.types";

interface IDCStoreData {
  getUnifiedOrderHistory: {
    dcOrderHistory: IDCStore[];
  };
}

interface IStoreOrderData {
  getUnifiedOrderHistory: {
    storeOrderHistory: IStoreOrder[];
  };
}

interface IBuyerCommentsData {
  getUnifiedBuyerComments: IBuyerComments;
}

interface IDCOrderHistoryTotalData {
  getUnifiedOrderHistoryTotal: {
    dcOrderTotalQtySellingUnits: number;
    dcOrderTotalQtyShippingUnits: number;
    dcOrderTotalQtyVendorUnits: number;
  };
}

interface IStoreOrderHistoryTotalData {
  getUnifiedOrderHistoryTotal: {
    storeOrderTotalQtySellingUnits: number;
    storeOrderTotalQtyShippingUnits: number;
    storeOrderTotalQtyVendorUnits: number;
  };
}

export function* getDcStoreDataSaga(
  action: ReturnType<typeof fetchDcStoreData>,
) {
  const { filters } = action.value;
  try {
    const response: ISuccessResponse<IDCStoreData> = yield call(
      getDCOrderHistoryData,
      transformFilterOptions(filters),
    );
    const data = response.data.getUnifiedOrderHistory.dcOrderHistory || [];
    yield put(fetchDcStoreDataSuccess(data));
  } catch (error) {
    console.log("getDcStoreDataSaga Error:", error);
    yield put(fetchDcStoreDataError());
  }
}

export function* getStoreOrderDataSaga(
  action: ReturnType<typeof fetchStoreOrderData>,
) {
  const { filters } = action.value;
  try {
    const response: ISuccessResponse<IStoreOrderData> = yield call(
      getStoreOrderHistoryData,
      transformFilterOptions(filters),
    );
    const data = response.data.getUnifiedOrderHistory.storeOrderHistory || [];
    yield put(fetchStoreOrderDataSuccess(data));
  } catch (error) {
    console.log("getStoreOrderDataSaga Error:", error);
    yield put(fetchStoreOrderDataError());
  }
}

export function* getBuyerCommentsDataSaga(
  action: ReturnType<typeof fetchBuyerCommentsData>,
) {
  const { filters } = action.value;
  try {
    const response: ISuccessResponse<IBuyerCommentsData> = yield call(
      getBuyerCommentsData,
      transformFilterOptions(filters),
    );
    yield put(
      fetchBuyerCommentsDataSuccess(response.data.getUnifiedBuyerComments),
    );
  } catch (error: any) {
    console.log("getBuyerCommentsDataSaga Error:", error);
    yield put(fetchBuyerCommentsDataError());
  }
}

export function* getDcStoreTotalSaga(
  action: ReturnType<typeof fetchDcStoreTotal>,
) {
  const { filters } = action.value;
  try {
    const totalsResponse: ISuccessResponse<IDCOrderHistoryTotalData> =
      yield call(getDCOrderHistoryTotal, transformFilterOptions(filters));
    const totals = {
      sellingUnits:
        totalsResponse.data.getUnifiedOrderHistoryTotal
          .dcOrderTotalQtySellingUnits || 0,
      shippingUnits:
        totalsResponse.data.getUnifiedOrderHistoryTotal
          .dcOrderTotalQtyShippingUnits || 0,
      vendorUnits:
        totalsResponse.data.getUnifiedOrderHistoryTotal
          .dcOrderTotalQtyVendorUnits || 0,
    };
    yield put(fetchDcStoreTotalSuccess(totals));
  } catch (error) {
    console.log("getDcStoreTotalSaga Error:", error);
    yield put(fetchDcStoreTotalError());
  }
}

export function* getStoreOrderTotalSaga(
  action: ReturnType<typeof fetchStoreOrderTotal>,
) {
  const { filters } = action.value;
  try {
    const totalsResponse: ISuccessResponse<IStoreOrderHistoryTotalData> =
      yield call(getStoreOrderHistoryTotal, transformFilterOptions(filters));
    const totals = {
      sellingUnits:
        totalsResponse.data.getUnifiedOrderHistoryTotal
          .storeOrderTotalQtySellingUnits || 0,
      shippingUnits:
        totalsResponse.data.getUnifiedOrderHistoryTotal
          .storeOrderTotalQtyShippingUnits || 0,
      vendorUnits:
        totalsResponse.data.getUnifiedOrderHistoryTotal
          .storeOrderTotalQtyVendorUnits || 0,
    };
    yield put(fetchStoreOrderTotalSuccess(totals));
  } catch (error) {
    console.log("getStoreOrderTotalSaga Error:", error);
    yield put(fetchStoreOrderTotalError());
  }
}
